import { useState } from 'react';

export default function ShareBar({ title }: { title: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('复制下面的链接分享给需要的人：', url);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={handleCopy}
        title={`复制链接分享：${title}`}
        className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-background-100"
      >
        <i className={copied ? 'ri-check-line text-secondary-600' : 'ri-link'} aria-hidden="true"></i>
        {copied ? '链接已复制' : '复制链接'}
      </button>
      <button
        type="button"
        onClick={() => window.print()}
        className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-background-100"
      >
        <i className="ri-printer-line" aria-hidden="true"></i>
        打印存档
      </button>
    </div>
  );
}